import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Icon from '@ant-design/icons';
import { InfoButton } from 'global/Securities/components/Form/TransactionForm/OrderTypeFormItem/styled';
import InfoSvg from 'global/Securities/components/Icons/InfoSvg';
import { formatBondCurrency } from 'features/securities/withdrawal/utils';
import PnLCurrency from 'features/trade/components/Portfolio/PnLCurrency';
import Collapsible from 'global/Collapsible';
import { Field, FieldSet } from '../../../styled';
import { BondInfoType } from '../../../constants';
import Accordion from '../../Accordion';
import { Container } from '../styled';
import { useBondInfoModal } from '../../../stores/useBondInfoModal';
import { useBondTaxStore } from '../../../stores/useBondTaxStore';

interface Props {
  finalAmount: number;
  tradeAmount: number;
  accruedInterest: number;
  totalTax: number;
  stampDuty: number;
  capitalGain: number;
  profitLossAmount: number;
  profitLossPercentage: number;
  sellerCoupon: number;
  // for tax
  accruedInterestExcludeTax: number;
  estimationAmountExcludeTax: number;
  realizedAmount: number;
}

export default function OrderContentSell({
  finalAmount = 0,
  tradeAmount = 0,
  accruedInterest = 0,
  totalTax = 0,
  stampDuty = 0,
  capitalGain = 0,
  profitLossAmount = 0,
  profitLossPercentage = 0,
  sellerCoupon = 0,
  // for tax
  accruedInterestExcludeTax = 0,
  estimationAmountExcludeTax = 0,
  realizedAmount = 0,
}: Props) {
  const openTaxModal = useBondTaxStore((s) => s.openTaxModal);
  const openInfoModal = useBondInfoModal((s) => s.openInfoModal);

  return (
    <>
      <Container>
        <Accordion
          title={
            <FieldSet>
              <Field isAccordion>
                <Text>Nominal Diterima</Text>
                <Text family="bold">{formatBondCurrency(finalAmount)}</Text>
              </Field>
            </FieldSet>
          }
          isPlain
          isTight
        >
          <FieldSet>
            <Field>
              <div>Nilai Penjualan</div>
              <div>{formatBondCurrency(tradeAmount)}</div>
            </Field>
            <Field>
              <Flex align="center">
                <Text>Kupon Berjalan</Text>
                <InfoButton
                  type="button"
                  onClick={() => openInfoModal(BondInfoType.ACCRUED_INTEREST)}
                >
                  <Icon
                    component={InfoSvg}
                    style={{
                      fontSize: 16,
                      color: '#969696',
                      marginLeft: 4,
                    }}
                  />
                </InfoButton>
              </Flex>
              <div>{formatBondCurrency(accruedInterest, 'exceptZero')}</div>
            </Field>
            <Field>
              <Flex align="center">
                <Text>Pajak Obligasi</Text>
                <InfoButton
                  type="button"
                  onClick={() =>
                    openTaxModal({
                      accruedInterest: accruedInterestExcludeTax,
                      amount: estimationAmountExcludeTax,
                      pl: realizedAmount,
                      totalTax,
                    })
                  }
                >
                  <Icon
                    component={InfoSvg}
                    style={{
                      fontSize: 16,
                      color: '#969696',
                      marginLeft: 4,
                    }}
                  />
                </InfoButton>
              </Flex>
              <div>{formatBondCurrency(totalTax * -1, 'exceptZero')}</div>
            </Field>
            <Field>
              <div>Bea Meterai</div>
              <div>{formatBondCurrency(stampDuty * -1, 'exceptZero')}</div>
            </Field>
            {sellerCoupon > 0 && (
              <Field>
                <Flex align="center">
                  Kupon Penjual
                  <InfoButton
                    type="button"
                    onClick={() =>
                      openInfoModal(BondInfoType.ACCRUED_INTEREST_SELLER)
                    }
                  >
                    <Icon
                      component={InfoSvg}
                      style={{
                        fontSize: 16,
                        color: '#969696',
                        marginLeft: 4,
                      }}
                    />
                  </InfoButton>
                </Flex>
                <div>{formatBondCurrency(sellerCoupon, 'exceptZero')}</div>
              </Field>
            )}
          </FieldSet>
        </Accordion>
      </Container>
      <Container>
        <Collapsible
          header={
            <FieldSet>
              <Field>
                <Text>P&L (Nett)</Text>
                <PnLCurrency
                  amount={profitLossAmount}
                  percentage={profitLossPercentage}
                  family="bold"
                />
              </Field>
            </FieldSet>
          }
        >
          <FieldSet>
            <Field>
              <Flex align="center">
                <Text>Kupon Berjalan</Text>
                <InfoButton
                  type="button"
                  onClick={() => openInfoModal(BondInfoType.ACCRUED_INTEREST)}
                >
                  <Icon
                    component={InfoSvg}
                    style={{
                      fontSize: 16,
                      color: '#969696',
                      marginLeft: 4,
                    }}
                  />
                </InfoButton>
              </Flex>
              <PnLCurrency
                amount={accruedInterest}
                isColorless={accruedInterest === 0}
                isSignless={accruedInterest <= 0}
              />
            </Field>
            <Field>
              <div>Capital Gain / Loss</div>
              <PnLCurrency
                amount={capitalGain}
                isColorless={capitalGain === 0}
                isSignless={capitalGain === 0}
              />
            </Field>
            <Field>
              {/* @ts-expect-error */}
              <Flex align="center" mb="16px">
                <Text>Pajak</Text>
                <InfoButton
                  type="button"
                  onClick={() => openInfoModal(BondInfoType.TAX)}
                >
                  <Icon
                    component={InfoSvg}
                    style={{
                      fontSize: 16,
                      color: '#969696',
                      marginLeft: 4,
                    }}
                  />
                </InfoButton>
              </Flex>
              <div>{formatBondCurrency(totalTax * -1, 'exceptZero')}</div>
            </Field>
          </FieldSet>
        </Collapsible>
      </Container>
    </>
  );
}
